import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import DescriptionRatings from 'automation-ui-management/constants/DescriptionRatings';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GeneratedDescriptionRatingButtons = ({
  rating,
  onRatingButtonClick
}) => {
  const getRatingLabel = () => {
    if (!rating) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.WorkflowNameWithDescription.GenerateDescriptionRatingButtons.rateDescription"
      });
    }
    if (rating === DescriptionRatings.THUMBS_UP) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.WorkflowNameWithDescription.GenerateDescriptionRatingButtons.satisfied"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.WorkflowNameWithDescription.GenerateDescriptionRatingButtons.dissatisfied"
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      as: "span",
      children: getRatingLabel()
    }), /*#__PURE__*/_jsxs(UIButtonGroup, {
      children: [/*#__PURE__*/_jsx(UIIconButton, {
        active: rating === DescriptionRatings.THUMBS_UP,
        "aria-label": I18n.text('automation-ui-management.WorkflowNameWithDescription.GenerateDescriptionRatingButtons.satisfied'),
        onClick: () => onRatingButtonClick(DescriptionRatings.THUMBS_UP),
        size: "small",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "emoji"
        })
      }), /*#__PURE__*/_jsx(UIIconButton, {
        active: rating === DescriptionRatings.THUMBS_DOWN,
        "aria-label": I18n.text('automation-ui-management.WorkflowNameWithDescription.GenerateDescriptionRatingButtons.dissatisfied'),
        onClick: () => onRatingButtonClick(DescriptionRatings.THUMBS_DOWN),
        size: "small",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "emojiLineSad"
        })
      })]
    })]
  });
};
export default GeneratedDescriptionRatingButtons;